module.exports = __webpack_public_path__ + "static/media/py.0656e5c3.svg";